import { AuthActionType } from 'enums';

export const setAuthLoading = (loading: boolean) =>
  ({ type: AuthActionType.LOADING, loading } as const);

export const setFullLoading = (fullLoading: boolean) =>
  ({ type: AuthActionType.FULL_LOADING, fullLoading } as const);

export const setLogIn = (data: { accessToken: string; refreshToken: string }) =>
  ({ type: AuthActionType.LOG_IN, data } as const);

export const setLogOut = () => ({ type: AuthActionType.LOG_OUT } as const);
export const setError = (message: string | string[] | null) =>
  ({ type: AuthActionType.ERROR, message } as const);

export const setUserInfo = (user: any) =>
  ({ type: AuthActionType.GET_USER_INFO, user } as const);

export const changePasswordAction = (isChangePassword: boolean) =>
  ({ type: AuthActionType.CHANGE_PASSWORD, isChangePassword } as const);

export const setNotification = (notification: string) =>
  ({ type: AuthActionType.SET_NOTIFICATION, notification } as const);

export const setRecoveryToken = (token: string) =>
  ({ type: AuthActionType.SET_RECOVERY_TOKEN, token } as const);

export const setTenant = (tenant: string) =>
  ({ type: AuthActionType.SET_TENANT, tenant } as const);
